module.exports = __webpack_public_path__ + "img/i_ar_list_order_on2.07f86148.svg";